// Écran de saisie d'une Facture client (vente).
import React from "react";
import { Receipt } from "lucide-react";
import SaisieFacture from "@/components/SaisieFacture";

export default function FactureClient() {
  return (
    <SaisieFacture
      config={{
        typeFacture: "client",
        endpoint: "/factures/client",
        titre: "Facture client",
        sousTitre: "Créez une facture à destination de vos clients.",
        icone: Receipt,
        tiersLabel: "Client",
        selecteurTiersTestId: "facture-selecteur-client",
        pageTestId: "page-facture-client",
        descriptionPlaceholder: "Description de la prestation ou du produit",
        showReference: true,
        referenceLabel: "Numéro de pièce original",
        journalCode: "VT",
        libelleJournal: "VT — Ventes",
        compteTva: "445710",
      }}
    />
  );
}
